const oldError = console.error
const oldWarn = console.warn

// Suppress known harmless warnings from Repeat/MUI Box interaction and
// ClickAwayListener data-filelocation (debug attribute from our babel plugin)
const suppressedPatterns = [
    "The following props are not supported: `data-filelocation`",
    "`remove` div",
    "`remove` li",
    "non-boolean attribute",
]

function isSuppressed(params) {
    const str = params.map(String).join(" ")
    return suppressedPatterns.some((p) => str.includes(p))
}

console.error = (...params) => {
    const firstParam = params[0]
    const message = typeof firstParam === "string" ? firstParam : String(firstParam)
    if (message.startsWith("Warning:")) {
        if (!isSuppressed(params)) {
            console.warn(...params)
        }
    } else {
        oldError(...params)
    }
}

console.warn = (...params) => {
    if (!isSuppressed(params)) {
        oldWarn(...params)
    }
}
